module.exports = __webpack_public_path__ + "static/csv_import_example-fd6e7098aacfb4634033b74e9b3ce2ba.png";